import React from 'react';

export default function CustomIcon({ stroke = 'black', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M46.5938 31.0625L60.5561 17.1001C61.9538 15.7024 64.3438 16.6923 64.3438 18.669V52.331C64.3438 54.3077 61.9538 55.2976 60.5561 53.8999L46.5938 39.9375M13.3125 55.4688H39.9375C43.6136 55.4688 46.5938 52.4886 46.5938 48.8125V22.1875C46.5938 18.5114 43.6136 15.5312 39.9375 15.5312H13.3125C9.63635 15.5312 6.65625 18.5114 6.65625 22.1875V48.8125C6.65625 52.4886 9.63636 55.4688 13.3125 55.4688Z"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
